import { css } from '@emotion/react';
import { observer } from 'mobx-react-lite';
import { UnstyledButton } from './UnstyledButton';

export interface BounceButtonProps {
  onClick: () => void;
  children: React.ReactNode;
  className?: string;
}

export const BounceButton = observer((props: BounceButtonProps) => {
  const { onClick, children, className } = props;

  return (
    <UnstyledButton
      onClick={onClick}
      css={[
        css({
          transition: 'scale 0.2s, filter 0.2s',
          '&:hover': {
            filter: 'brightness(0.8)',
          },
          '&:active': {
            scale: 0.9,
          },
        }),
      ]}
      className={className}
    >
      {children}
    </UnstyledButton>
  );
});
